import { render, staticRenderFns } from "./CustomFieldParagraph.vue?vue&type=template&id=388d8430"
import script from "./CustomFieldParagraph.vue?vue&type=script&lang=js"
export * from "./CustomFieldParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports